import styled from 'styled-components';

import { BREAKPOINTS } from '../styles';

const GRID = {
  GAP: {
    SMALL: '24px',
    MEDIUM: '32px',
    LARGE: '40px',
  },
  GUTTER: {
    SMALL: '16px',
    MEDIUM: '32px',
    LARGE: '56px',
  },
};

export const PageWidth = styled.div`
  display: block;
  margin: 0 ${GRID.GUTTER.SMALL};

  ${BREAKPOINTS.MEDIUM} {
    margin: 0 ${GRID.GUTTER.MEDIUM};
  }

  ${BREAKPOINTS.LARGE} {
    margin: 0 ${GRID.GUTTER.LARGE};
  }

  ${BREAKPOINTS.XLARGE} {
    width: 1120px;
    margin: 0 auto;
  }
`;

export const Columns = styled.section<{ gap?: string; columns?: string; printColumns?: string }>`
  width: 100%;
  display: grid;
  grid-gap: ${props => props.gap || GRID.GAP.SMALL};
  word-break: break-word; /* Prevent long words from breaking the layout – consider making this rule global */

  ${BREAKPOINTS.MEDIUM} {
    grid-template-columns: ${props => props.columns};
    -ms-grid-columns: ${props => props.columns};
    grid-gap: ${props => props.gap || GRID.GAP.MEDIUM};
  }

  ${BREAKPOINTS.LARGE} {
    grid-gap: ${props => props.gap || GRID.GAP.LARGE};
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: -ms-grid;

    > *:not(:first-child) {
      margin-left: ${GRID.GAP.MEDIUM};
    }
  }

  @media print {
    grid-gap: 0;
    grid-template-columns: ${props => props.printColumns || 'none'};
  }
`;

export const ContainerMargins = styled.div`
  /* X small devices (mobile phones, 320px and up) */
  @media only screen and (min-width: 320px) {
    margin: 16px;
    column-gap: 16px;
  }

  /* Small devices (portrait tablets, 576px and up) */
  @media only screen and (min-width: 576px) {
    margin: 16px;
    column-gap: 16px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    margin: 32px;
    column-gap: 32px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    margin: 56px;
    column-gap: 24px;
  }

  /* X large devices (laptops/desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    margin: 56px;
    column-gap: 40px;
  }
`;
